module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Careers with " + _vm._s(_vm.siteName))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Open Positions",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, _vm._l((_vm.positions), function(item) {
    return _c('div', {
      staticClass: "position-item"
    }, [_c('div', {
      staticClass: "posted-date"
    }, [_vm._v("Posted " + _vm._s(_vm.getFormatedDate(item.postedDate)))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [(item.titlePrefix) ? _c('span', [_vm._v(_vm._s(item.titlePrefix) + ": ")]) : _vm._e(), _vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), (item.url) ? _c('div', {}, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_vm._v("View and Apply for this Position >")])]) : _vm._e()])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', [_vm._v("Working in Scholarly Publishing is.. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9c570d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/CareersPage.vue
// module id = 1476
// module chunks = 1